import { useEffect } from 'react';

const useFilter = (search, setSubmissionData, submissionsDataCache, collectionID) => {
    useEffect(() => {
        if (Object.entries(search).length < 1) {
            sessionStorage.setItem('SubmissionData', null);
            sessionStorage.setItem('search', '{}');
            setSubmissionData(submissionsDataCache);
        } else {
            const getTypeOrValue = value =>
                typeof value === 'string' ? value.toLowerCase() : value;

            const filteredSubmissionData = submissionsDataCache.filter(item => {
                const filterKeys = Object.keys(search);

                return filterKeys.every(key => {
                    if (!search[key].length) return true;

                    if (key === 'staff-role') {
                        return search[key].some(
                            filter =>
                                item['staff-role'] &&
                                item['staff-role'].value.toLowerCase() === filter.toLowerCase()
                        );
                    }

                    if (key === 'actions') {
                        const derivedActions = [];

                        if (item.status === 'transferred-in') {
                            derivedActions.push('transferred-in');
                        }

                        if (item.dq_warning === true) {
                            derivedActions.push('incomplete');
                        }

                        return search[key].some(filter => derivedActions.includes(filter));
                    }

                    // General filter criteria
                    return search[key].some(
                        filter => getTypeOrValue(filter) === getTypeOrValue(item[key])
                    );
                });
            });

            setSubmissionData(filteredSubmissionData);
            sessionStorage.setItem('SubmissionData', JSON.stringify(filteredSubmissionData));
            sessionStorage.setItem('search', JSON.stringify(search));
            sessionStorage.setItem('collectionID', collectionID);
        }
    }, [search, setSubmissionData, submissionsDataCache, collectionID]);
};

export default useFilter;
